var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriceQuestion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.817,
    height: 23.817,
    viewBox: "0 0 23.817 23.817",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Question_1864288",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M14.409,2.5A11.909,11.909,0,1,0,26.317,14.409,11.919,11.919,0,0,0,14.409,2.5Zm0,19.129a1.279,1.279,0,1,1,1.279-1.279A1.268,1.268,0,0,1,14.409,21.629Zm1.254-6.568a.4.4,0,0,0-.226.376v1.279a1,1,0,1,1-2.006,0V15.436a2.411,2.411,0,0,1,1.63-2.306,2.006,2.006,0,0,0,1.354-2.281A2.012,2.012,0,0,0,13.155,9.67a1.981,1.981,0,0,0-.752,1.554,1,1,0,1,1-2.006,0,4.006,4.006,0,0,1,1.429-3.084,3.93,3.93,0,0,1,3.309-.877,4.033,4.033,0,0,1,.526,7.8Z",
    transform: "translate(-2.5 -2.5)",
    fill: "#038DE3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceQuestion);
export default __webpack_public_path__ + "static/media/priceQuestion.428ae47d7b8b9b5b642bb7591296402b.svg";
export { ForwardRef as ReactComponent };